import { Controller } from "stimulus"

export default class extends Controller {
  autogrow() {
    this.element.style.height = `${this.element.scrollHeight}px`
  }
}
